import { Component, Input, QueryList } from '@angular/core';
import { PendingActionInterface } from '@app/core/interfaces';
import * as fromMyClaims from '@app/my-zone/pages/claims/store';
import { PanelExpandableComponent } from '@app/shared/ux/panel-expandable/panel-expandable.component';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'ins-pending-actions-container',
    template: ` <ins-pending-actions [children]="children" [actions]="actions$ | async"> </ins-pending-actions> `,
})
export class PendingActionsContainer {
    @Input() children: QueryList<PanelExpandableComponent>;

    public actions$: Observable<PendingActionInterface> = this.store.pipe(
        select(fromMyClaims.getSelectedActions),
        filter((action) => Boolean(action)),
    );

    constructor(private store: Store<fromMyClaims.State>) {}
}
